/**
 * @author Tanmay <tanmay.pawar@314ecorp.com>
 * @description grafana faro logging initialization
 */

import {
	Faro,
	FetchTransport,
	TransportItem,
	browserMeta,
	getWebInstrumentations,
	initializeFaro as coreInit,
} from '@grafana/faro-react';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';
import { getDefaultOTELInstrumentations, TracingInstrumentation } from '@grafana/faro-web-tracing';

import config from 'configs/index';
import env from 'utils/Environment';

const origin = window.location.origin;
const hostname = new URL(origin).hostname;
const tenant = hostname.split('.')[0];

const Env = env.getEnvironment();
const isLocalhost = env.isLocalhost();

const API_V1_REGEX = /^[^]*?\/api\/v1\/[^]*$/;

export const initializeFaro = (): Faro => {
	return coreInit({
		transports: [
			new FetchTransport({
				url: config.faro.url,
				apiKey: config.faro.apiKey,
				bufferSize: 1000,
				concurrency: 5,
				defaultRateLimitBackoffMs: 1000,
			}),
		],
		isolate: true,
		app: { name: config.appName, version: VERSION_NO, environment: Env, namespace: tenant },
		instrumentations: [
			...getWebInstrumentations({ captureConsole: true, captureConsoleDisabledLevels: [] }),
			new TracingInstrumentation({
				instrumentations: [
					...getDefaultOTELInstrumentations({
						propagateTraceHeaderCorsUrls: [API_V1_REGEX],
					}),
					new FetchInstrumentation({
						propagateTraceHeaderCorsUrls: [API_V1_REGEX],
					}),
					new XMLHttpRequestInstrumentation({
						propagateTraceHeaderCorsUrls: [API_V1_REGEX],
					}),
				],
			}),
		],
		metas: [browserMeta],
		beforeSend: (item: TransportItem) => {
			if (isLocalhost) {
				return null;
			}
			delete item.meta.sdk;
			return item;
		},
	});
};
